import React, { useState } from 'react';

import { FavoritePages } from 'App/components/FavoritePages';
import { isGoGameEnv } from 'App/constants';
import externalLinks from 'App/externalLinks';
import { useCurrentUser } from 'Auth';
import { useLogo } from 'components/hooks/useLogo';

import { SidePage, SearchInput, makeStyles, Stack } from '@gogame/components';
import { Navigation } from '@gogame/screens';

import { LEFT_DRAWER_Z_INDEX } from '../Sidebar/constants';

const useStyles = makeStyles(() => ({
  bigImage: {
    display: 'block',
    height: ({ isNewYearPeriod }) => (isNewYearPeriod ? '34px' : '28px'),
    marginLeft: '4px',
    width: '248px',
  },
}));

const NavigationSidePage = ({ open, onClose, onExited }) => {
  const user = useCurrentUser();
  const { fullLogoUrl, isNewYearPeriod } = useLogo();
  const classes = useStyles({ isNewYearPeriod });
  const [searchQuery, setSearchQuery] = useState('');

  const handleChangeSearchQuery = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleClearSearchQuery = () => {
    setSearchQuery('');
  };

  return (
    <SidePage
      open={open}
      onClose={onClose}
      onExited={onExited}
      size={isGoGameEnv ? 'xl' : 's'}
      backdrop={false}
      direction={'right'}
      directionOfset={'64px'}
      zIndex={LEFT_DRAWER_Z_INDEX}
    >
      <SidePage.Title onClose={onClose}>
        <Stack
          direction={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}
          spacing={12}
        >
          <svg className={classes.bigImage}>
            <use href={fullLogoUrl + '#logo'}></use>
          </svg>

          {isGoGameEnv && !user?.isBlocked ? (
            <SearchInput
              value={searchQuery}
              onChange={handleChangeSearchQuery}
              onClear={handleClearSearchQuery}
              debounceTimeout={400}
              autoFocus={true}
              minWidth={'480px'}
            />
          ) : null}
        </Stack>
      </SidePage.Title>
      <SidePage.Content disableGutters={true} disableScroll={true}>
        {isGoGameEnv && !user?.isBlocked ? (
          <FavoritePages>
            {({ favorites, onChange }) => (
              <Navigation
                searchQuery={searchQuery}
                favorites={favorites}
                onChangeFavorites={onChange}
                columnCount={isGoGameEnv ? 3 : 1}
                withFavorite={true}
                externalLinks={externalLinks}
                onClose={onClose}
              />
            )}
          </FavoritePages>
        ) : (
          <Navigation columnCount={1} withFavorite={false} onClose={onClose} />
        )}
      </SidePage.Content>
    </SidePage>
  );
};

export default NavigationSidePage;
